import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryDesktopIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 1.75H2C1.04 1.75 0.25 2.54 0.25 3.5V17.5C0.25 18.46 1.04 19.25 2 19.25H11.25V20.75H6C5.59 20.75 5.25 21.09 5.25 21.5C5.25 21.91 5.59 22.25 6 22.25H18C18.41 22.25 18.75 21.91 18.75 21.5C18.75 21.09 18.41 20.75 18 20.75H12.75V19.25H22C22.96 19.25 23.75 18.46 23.75 17.5V3.5C23.75 2.54 22.96 1.75 22 1.75ZM22.25 17.5C22.25 17.64 22.14 17.75 22 17.75H2C1.86 17.75 1.75 17.64 1.75 17.5V3.5C1.75 3.36 1.86 3.25 2 3.25H22C22.14 3.25 22.25 3.36 22.25 3.5V17.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryDesktopIcon.displayName = 'LibraryDesktopIcon';
